import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Button from "sushiweb/Button";
import Dialog from "@material-ui/core/Dialog";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Input from "@material-ui/core/Input";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Avatar from "@material-ui/core/Avatar";
import Chip from "@material-ui/core/Chip";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { makeStyles } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import commonStyles from "../../../static/styles/common";
import * as CityPropertyActions from "../../../store/actions/CityProperty";
import * as GenSettingActions from "../../../store/actions/GenSetting";
import TableFields from "../../../constants/LevelList/Tablefields.json";
import { isLevelValidated } from "../HelperFunctions";
import Check from "sushiweb/Icons/all/Check";
import JSONInput from "react-json-editor-ajrm";
import locale from "react-json-editor-ajrm/locale/en";
import black from "sushiweb/tokens/color/black";
import { AddEdit, Delete, check, Cross } from "sushiweb/Icons";
import { isEmpty } from "../../../utils/index";

const useStyles = makeStyles((theme) => ({
  ...commonStyles.tableListStyles,
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  errorSpacing: {
    marginTop: "1.25rem",
  },
  button: {
    marginTop: "1.25rem",
    margin: theme.spacing(1),
    className: "shushi-btn",
    width: "12.5rem",
    height: "2.75rem",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CustomTableCell = ({ level, name, onChange, onChangePriority, idx }) => {
  const classes = useStyles();
  const { isEditMode } = level;
  let val =
    typeof level[name] === "object" ? JSON.stringify(level[name]) : level[name];
  return (
    <TableCell align="left" className={classes.tableCell}>
      {typeof level[name] == "object" ? (
        <div>
          <JSONInput
            id={name + String(idx)}
            placeholder={level[name]}
            locale={locale}
            height="auto"
            onChange={(e) => onChange(e, level, idx, name)}
            colors={{
              colon: "#2781E7",
              string: "#FA7921",
              number: "#4B9B42",
              background: "#00000000",
              keys: "#1E1E1E",
              default: black,
            }}
            confirmGood={false}
            theme="light_mitsuketa_tribute"
          />
        </div>
      ) : (
        <Input
          id={level + name + idx}
          required={true}
          fullWidth={false}
          multiline={false}
          value={level[name]}
          name={name}
          autoFocus={true}
          onChange={(e) => onChangePriority(e, level, idx)}
        />
      )}
    </TableCell>
  );
};

const LevelFormModal = (props) => {
  const classes = useStyles();
  const [formError, setFormError] = useState("");
  const {
    modalState,
    handleModalClose,
    activeRule,
    setActiveRule,
    activeCityProperty,
    activeGenSetting,
    finalConfig,
    createdRule,
  } = props;
  const [levels, SetLevel] = useState(() => {
    if (activeRule.levels == undefined) {
      activeRule.levels = [];
      setActiveRule(activeRule);
    }
    return activeRule.levels;
  });

  const handleSubmit = (evt) => {
    evt.preventDefault();
    let correct = true;
    let errMsg = "";
    // validate Levels
    levels.map((level, idx) => {
      let validated = isLevelValidated([level]);
      if (validated != "validated") {
        correct = false;
        errMsg += " " + idx.toString();
      }
      try {
        level.activation = JSON.parse(level.activation);
      } catch (error) {}
      try {
        level.actions = JSON.parse(level.actions);
      } catch (error) {}
      return level;
    });
    if (!correct) {
      let msg = "level at index " + errMsg + " " + "are invalid";
      setFormError(msg);
    } else {
      levels.forEach((level) => {
        if (level.isEditMode != undefined) {
          delete level.isEditMode;
        }
        if (
          level.actions.others != undefined &&
          isEmpty(level.actions.others)
        ) {
          delete level.actions.others;
        }
      });

      activeRule.levels.forEach((level) => {
        if (level.isEditMode != undefined) {
          delete level.isEditMode;
        }
        if (
          level.actions.others != undefined &&
          isEmpty(level.actions.others)
        ) {
          delete level.actions.others;
        }
      });
      // Set Final Config and levels
      if (JSON.stringify(activeRule.levels) != JSON.stringify(levels)) {
        SetLevel(levels);
        activeRule.levels = levels;
        activeRule.is_modified = true;
        if (!isEmpty(activeCityProperty)) {
          activeRule.is_city_property = true;
        }
        let newfinalConfig = JSON.parse(JSON.stringify(finalConfig));
        newfinalConfig = newfinalConfig.map((rule) => {
          if (
            rule.rule_name == activeRule.rule_name &&
            rule.priority == activeRule.priority
          ) {
            return activeRule;
          }
          return rule;
        });
        props.setFinalConfig({
          rules: newfinalConfig,
        });
        // check if newly created RUle is being edited
        if (!isEmpty(createdRule) && activeRule.is_new != undefined) {
          props.setcreatedRule(activeRule);
        }
        // check if city is selected
        else if (!isEmpty(activeCityProperty) && activeRule.is_city_property) {
          if (activeCityProperty.value.rules == undefined) {
            activeCityProperty.value.rules = [activeRule];
          } else {
            var found = false;
            let newCityProperty = activeCityProperty.value.rules.map((rule) => {
              if (
                rule.rule_name == activeRule.rule_name &&
                rule.priority == activeRule.priority
              ) {
                rule = activeRule;
                found = true;
              }
              return rule;
            });
            activeCityProperty.value.rules = newCityProperty;
            if (!found) {
              activeCityProperty.value.rules.push(activeRule);
            }
            props.setActiveCityProperty(activeCityProperty);
          }
        } else {
          // if none of the above is true
          let newGenSetting = activeGenSetting.value.rules.map((rule) => {
            if (rule.rule_name == activeRule.rule_name) {
              rule = activeRule;
            }
            return rule;
          });
          activeGenSetting.value.rules = newGenSetting;
          props.setActiveGenSetting(activeGenSetting);
        }
      }
      SetLevel([]);
      handleModalClose();
    }
  };

  useEffect(() => {
    levels.map((level) => {
      level.isEditMode = false;
      if (level.actions == undefined) {
        level.actions = {};
      } else {
        if (
          level.actions.others != undefined &&
          isEmpty(level.actions.others)
        ) {
          delete level.actions.others;
        }
        if (level.actions.self != undefined && isEmpty(level.actions.self)) {
          delete level.actions.self;
        }
      }
      if (level.activation == undefined) {
        level.activation = {};
      }
    });
  }, []);

  const onDelete = (idx) => {
    var newLevel = [];
    levels.map((level, index) => {
      if (index != idx) {
        newLevel.push(level);
      }
    });
    SetLevel(newLevel);
  };

  const onChange = (e, level, idx, name) => {
    const value = e.jsObject;
    if (value != undefined) {
      const newLevels = levels.map((level, index) => {
        if (idx === index) {
          return { ...level, [name]: value };
        }
        return level;
      });
      SetLevel(newLevels);
    }
  };

  const onChangePriority = (e, level, idx) => {
    const value = e.target.value;
    const name = e.target.name;
    const newLevels = levels.map((level, index) => {
      if (idx === index) {
        return { ...level, [name]: value };
      }
      return level;
    });
    if (value.length) {
      newLevels.sort((a, b) =>
        a.priority < b.priority ? 1 : b.priority < a.priority ? -1 : 0
      );
    }
    SetLevel(newLevels);
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={!!modalState}
        onClose={handleModalClose}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="scroll-dialog-feature"
        aria-describedby="scroll-dialog-description"
        id="editLevelFormModal"
      >
        <AppBar className={classes.appBar} color="transparent">
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleModalClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              <Chip avatar={<Avatar>R</Avatar>} label={activeRule.rule_name} />
            </Typography>
          </Toolbar>
        </AppBar>
        <form
          onSubmit={handleSubmit}
          className={classes.root}
          noValidate
          autoComplete="off"
        >
          <DialogContent dividers>
            <Paper className={classes.root}>
              <Table className={classes.table} aria-label="caption table">
                <TableHead>
                  <TableRow className={classes.tableHeadRow}>
                    <TableCell align="left" />
                    {TableFields.map((field, index) => {
                      return (
                        <TableCell
                          key={field.heading + index}
                          className={classes.header}
                        >
                          {field.heading}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {levels.map((level, idx) => (
                    <TableRow
                      key={String(level.priority) + String(idx)}
                      className={classes.tableBodyRow}
                    >
                      <TableCell
                        key={level.priority}
                        className={classes.selectTableCell}
                      >
                        <IconButton
                          aria-label="delete"
                          onClick={() => onDelete(idx)}
                        >
                          <Delete color="red" />
                        </IconButton>
                      </TableCell>
                      <CustomTableCell
                        {...{
                          level,
                          name: "priority",
                          onChange,
                          onChangePriority,
                          idx,
                        }}
                      />
                      <CustomTableCell
                        {...{
                          level,
                          name: "activation",
                          onChange,
                          onChangePriority,
                          idx,
                        }}
                      />
                      <CustomTableCell
                        {...{
                          level,
                          name: "actions",
                          onChange,
                          onChangePriority,
                          idx,
                        }}
                      />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleSubmit}
              root="submitButton"
              type="submit"
              variant="contained"
              className={classes.button}
              size="compressed"
            >
              {"Submit"}
            </Button>
          </DialogActions>
          <div>
            {formError.length > 0 ? (
              <div className={`error-state ${classes.errorSpacing}`}>
                {"*" + formError}
              </div>
            ) : (
              ""
            )}
          </div>
        </form>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { GenSetting, CityProperty } = state;
  return {
    finalConfig: GenSetting.finalConfig,
    activeGenSetting: GenSetting.activeGenSetting,
    activeCityProperty: CityProperty.activeCityProperty,
    createdRule: GenSetting.activeRule,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFinalConfig: bindActionCreators(
      GenSettingActions.setFinalConfig,
      dispatch
    ),
    setActiveGenSetting: bindActionCreators(
      GenSettingActions.setActiveGenSetting,
      dispatch
    ),
    setActiveCityProperty: bindActionCreators(
      CityPropertyActions.setActiveCityProperty,
      dispatch
    ),
    setcreatedRule: bindActionCreators(
      GenSettingActions.setActiveRule,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LevelFormModal);
